import React from 'react'

// Material-UI
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'

import VisibilityOffIcon from '@material-ui/icons/VisibilityOffRounded'
import VisibilityOnIcon from '@material-ui/icons/VisibilityRounded'

import { useLogin } from './useLogin'


/** Sign In Page */
const EmailLoginForm = () => {
  const [showPassword, setShowPassword] = React.useState(false)
  const login = useLogin()

  function handleSubmit(event) {
    event.preventDefault()

    login({
      email: event.target.email.value,
      password: event.target.password.value,
    })
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              autoFocus
              label="Email"
              variant="filled"
              type="email"
              name="email"
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Password"
              variant="filled"
              type={showPassword ? 'text' : 'password'}
              required
              name="password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityOnIcon />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              id="log-in-button"
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
            >
              Log In
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export { EmailLoginForm }
